import { ReactSVG } from 'react-svg';
import { RowView } from '../../components';
import AuthWrapper from '../../components/AuthWrapper';
import PendingApplicationsFunctional from './index.function';
import Text from '../../components/Text';
import { fontSizes } from '../../constants/constants';
import Loader from '../../components/Loader';
import ViewItems from '../../components/ViewItems';
import Button from '../../components/Button';
import images from '../../constants/images';
import Language from '../../components/Language';
import AccountCard from '../../components/AccountCard';

const PendingApplications = () => {
  const { isArabic, TextWeight, direction, applications, authLoading, nafath_loading, onPressApplication, handleNewApplication, user, applications_loading, getContentKey } =
    PendingApplicationsFunctional();

  return (
    <AuthWrapper>
      <div className='w-full'>
        <RowView className='justify-between items-center'>
          <img src={images.textLogo} width={70} />
          <div className="flex justify-end">
            <Language isLogin />
          </div>
        </RowView>

        <Text
          text={getContentKey('choose_application_heading')}
          align={isArabic ? 'text-right' : 'text-left'}
          weight={TextWeight.semiBold}
          size={fontSizes.h18}
          className={'block mt-2'}
        />

        <div dir={direction} className='max-h-[450px] overflow-auto mt-4 space-y-4'>
          <AccountCard
            loading={applications_loading}
            data={applications}
            isPending={true}
            onPressApplication={onPressApplication}
          />
        </div>

        {
          !user?.isIndividualApplicationExist && (
            <Button text={getContentKey('btn_create_new_application')} className='w-full mt-10' onClick={handleNewApplication} loading={authLoading} />
          )
        }
      </div>
    </AuthWrapper>
  );
};

export default PendingApplications;
